export function createNavbarTransparentEffect() {
  function onScroll(e) {
    const navbar = document.getElementsByClassName("header-navbar")[0];
    const navInner = document.getElementsByClassName("navbar-container")[0];
    if (!navbar || !navInner) return;

    const top = e?.target?.documentElement?.scrollTop ?? window.scrollY ?? 0;

    if (top > 100) {
      navbar.classList.remove("in-animation-nav");
      navbar.classList.add("out-animation-nav");
      setTimeout(() => {
        navInner.classList.remove("tranparent-background-nav");
        navbar.classList.remove("tranparent-background-nav");
      }, 500);
    } else {
      navbar.classList.remove("out-animation-nav");
      navbar.classList.add("in-animation-nav");
      setTimeout(() => {
        navInner.classList.add("tranparent-background-nav");
        navbar.classList.add("tranparent-background-nav");
      }, 500);
    }
  }

  function onResize() {
    const navbarInvisible = document.querySelector(".header-navbar.navbar-shadow");
    if (navbarInvisible) navbarInvisible.style.setProperty("background", "none", "important");
  }

  return {
    mount() {
      window.addEventListener("scroll", onScroll);
      window.addEventListener("resize", onResize);

      onScroll({ target: document });
      onResize();
    },
    unmount() {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);
    },
  };
}
